var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 105,
    viewBox: "0 0 127 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1139_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9352 69.9836L77.25 13.5125C82.8596 8.587 92.66 11.2256 93.8235 17.9746L105.319 84.6607C106.269 90.1684 100.618 94.8989 94.1336 94.0251L18.323 83.8101C10.5876 82.7678 7.47433 74.7784 12.9352 69.9836Z",
    fill: "url(#paint0_linear_1139_262)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0797 49.262L63.0038 59.0561L79.813 49.3195M63 76.425V59.0408M66.9675 76.2429C65.875 76.8562 64.4375 77.1629 63 77.1629C61.5625 77.1629 60.125 76.8562 59.0325 76.2429L48.7975 70.5695C46.4783 69.2854 44.5808 66.0654 44.5808 63.4204",
    stroke: "#108DA0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4192 59.5908V52.5758C81.4192 49.9308 79.5217 46.7108 77.2025 45.4266L66.9675 39.7533C64.7825 38.5266 61.2175 38.5266 59.0325 39.7533L48.7975 45.4266C46.4783 46.7108 44.5808 49.9308 44.5808 52.5758M84.0833 77.1666L82.1667 75.2499M76.8 76.0166C78.4267 76.0166 79.9867 75.3704 81.1369 74.2202C82.2871 73.0699 82.9333 71.5099 82.9333 69.8833C82.9333 68.2566 82.2871 66.6966 81.1369 65.5463C79.9867 64.3961 78.4267 63.7499 76.8 63.7499C75.1733 63.7499 73.6133 64.3961 72.4631 65.5463C71.3129 66.6966 70.6667 68.2566 70.6667 69.8833C70.6667 71.5099 71.3129 73.0699 72.4631 74.2202C73.6133 75.3704 75.1733 76.0166 76.8 76.0166V76.0166Z",
    stroke: "#108DA0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.3 28.5796L114.8 32.3933",
    stroke: "#108DA0",
    strokeWidth: 2.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 28.8337L120.2 32.6474",
    stroke: "#108DA0",
    strokeWidth: 2.9,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 41.1223L119.9 37.3086",
    stroke: "#108DA0",
    strokeWidth: 2.9,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40.7834L114.5 37.0544",
    stroke: "#108DA0",
    strokeWidth: 2.9,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1139_262",
    x: 0.182495,
    y: 0.972168,
    width: 115.241,
    height: 103.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1139_262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1139_262",
    x1: 122.995,
    y1: 27.651,
    x2: 47.3759,
    y2: 120.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4FF99",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.9296b275149d5398f5b1b20b5d4f7cfa.svg";
export { ForwardRef as ReactComponent };